import { render, staticRenderFns } from "./VocaltionalFunctionManagement.vue?vue&type=template&id=926e53d2&scoped=true"
import script from "./VocaltionalFunctionManagement.vue?vue&type=script&lang=js"
export * from "./VocaltionalFunctionManagement.vue?vue&type=script&lang=js"
import style0 from "./VocaltionalFunctionManagement.vue?vue&type=style&index=0&id=926e53d2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926e53d2",
  null
  
)

export default component.exports